module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Regular.684f853e487c3913ebe859381122d079.ttf";